angular.module('unica_campaign.campaign_controllers')

.controller('CampaignAssignController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	InvitationListListService, UserListService, InvitationGroupListService,
	CampaignAssignService, CampaignEditService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.id       = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.searchData = {};

	$scope.clearSearch = function() {
		$scope.searchData = {
			event_id: $stateParams.event_id
		};
	};
	$scope.clearSearch();

	$scope.getCampaign( $stateParams.id );
	$scope.$on('campaign_loaded', function() {
		if ( $scope.campaignData.filter ) {
			$scope.searchData = JSON.parse( $scope.campaignData.filter );
		}
	});



	$scope.loadInvitationLists = function()
	{
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsLists = data;
				}
			});
	};

	$scope.loadInvitationGroups = function()
	{
		$scope.showLoader();

		InvitationGroupListService
			.list( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationGroups = data;
				}
			});
	};



	$scope.openImportInvitationsCampaignCFModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationsCampaignCFInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitations-cf-ca-il.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			if ( data.created.length > 0 ) {
				$scope.loadAssigns();
			}

		}, function () { });
	};



	$scope.loadAssigns = function()
	{
		$scope.showLoader();

		CampaignAssignService
			.list( $stateParams.event_id, $stateParams.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.campaignEmails = data;
				}
			});
	};

	$scope.loadInvitationLists();
	$scope.loadInvitationGroups();
	$scope.loadAssigns();

	$scope.userList = [];
	$scope.advancedSearch = function()
	{
		$scope.showLoader();

		UserListService
			.advancedSearch( $scope.searchData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.userList = data;
				}
			});
	};

	var allUserChecked = false;
	$scope.toggleAllUsers = function() {
		allUserChecked = !allUserChecked;
		angular.forEach($scope.userList, function(user, key) {
			user.checked = ( allUserChecked ? true : false );
			$scope.userList[key] = user;
		});
		$scope.checkAllDisabled();
	};

	$scope.toggleUser = function(userId) {
		angular.forEach($scope.userList, function(user, key) {
			if ( user.id === userId ) {
				user.checked = !user.checked;
				$scope.userList[key] = user;
			}
		});
		$scope.checkAllDisabled();
	};

	$scope.inviteAllDisabled = true;
	$scope.checkAllDisabled = function() {
		$scope.inviteAllDisabled = true;
		angular.forEach($scope.userList, function(user, key) {
			if ( user.checked ) {
				$scope.inviteAllDisabled = false;
			}
		});
	};

	$scope.inviteUser = function( invitationId) {
		$scope.inviteSelectedUser( [ invitationId ] );
	};


	$scope.inviteSelectedUser = function(invitationIds)
	{
		if (!invitationIds) {
			invitationIds = [];
			angular.forEach($scope.userList, function(inv, key) {
				if ( inv.checked ) {
					invitationIds.push(inv.invitation_id);
				}
			});
		}

		$scope.showLoader();
		CampaignAssignService
			.assign($stateParams.event_id, $stateParams.id, invitationIds )
			.then(function(data) {
				$scope.hideLoader();

				$scope._updateFilter();

				if ( data ) {
					$scope.showSuccessMsg( data + ' destinatari aggiunti con successo!', '');
					$scope.loadAssigns();
				} else {
					$scope.showSuccessMsg( '0 destinatari aggiunti con successo!', '');
				}
			});
	};

	$scope._updateFilter = function()
	{
		CampaignEditService
			.updateFilter( $stateParams.id, $scope.searchData )
			.then(function(data) {
				$scope.clearSearch();
				$scope.userList = [];
			});
	};


	$scope.deleteCampaignEmail = function( campaignEmailId )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il destinatario?',
			text: 'Confermi la cancellazione del destinatario?'
		}).then(function() {

			$scope.showLoader();
			CampaignAssignService
				.delete( campaignEmailId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.campaignEmails, function(campaignEmail, key) {
							if ( campaignEmail.id === campaignEmailId ) {
								$scope.campaignEmails.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Destinatario eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

})

	.controller('ModalImportInvitationsCampaignCFInstanceController',
		function (
			$scope, $stateParams, $rootScope,
			$uibModalInstance, FileUploader, getBaseApiURL, Session
		) {

			$scope.importInvitationsData = {
				file: '',
				csv: ''
			};

			$scope.uploader = new FileUploader({
				removeAfterUpload: true,
				alias: 'csv',
				url: getBaseApiURL + '/import/assign-invitations/' + $stateParams.id,
				headers: {
					Authorization : 'Bearer ' + Session.token,
					Accept: 'application/json'
				}
			});


			$scope.uploader.onAfterAddingFile = function( fileItem ) {
				$scope.importInvitationsData.file = fileItem;
				$scope.importInvitationsData.csv = fileItem.file.name;
			};

			$scope.uploader.onCompleteItem = function(fileItem, response) {
				$scope.hideLoader();
				if ( response.result === 'ko' && response.message ) {
					$rootScope.showErrorMsg( response.message );
				} else {
					$scope.showSuccessMsg('Operazione completata');
				}
				$uibModalInstance.close( response );
			};

			$scope.deleteImportInvitationsCFCsv = function() {
				// angular.element(document.querySelector('.invitations_csv')).val(null);
				$scope.uploader.removeFromQueue( $scope.importInvitationsData.file );
				$scope.importInvitationsData.file = '';
				$scope.importInvitationsData.csv = '';
			};

			$scope.importInvitationsCF = function () {
				$scope.showLoader();
				$scope.uploader.uploadAll();
			};

			$scope.closeModal = function() {
				$uibModalInstance.dismiss('cancel');
			};

		});